import { FC, ReactNode } from 'react';
import styles from './styles.module.css';
import Page from '../../components/Page';
import { Tab, TabList } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';

type Tab = 'Consultant Biographies' | 'Job Roles' | 'Prompt Adjuster';

const MasterLists: FC<{
  selectedTab: Tab;
  children?: ReactNode;
}> = ({ children, selectedTab }) => {
  const tabs: Record<Tab, string> = {
    'Consultant Biographies': '/admin/consultantbios',
    'Job Roles': '/admin/jobroles',
    'Prompt Adjuster': '/admin/promptadjuster',
  };

  const navigate = useNavigate();

  const onTabSelect = (tab: Tab) => {
    navigate(tabs[tab]);
  };

  return (
    <Page>
      <TabList
        defaultSelectedValue="tab2"
        selectedValue={selectedTab}
        onTabSelect={(_, tab) => onTabSelect(tab.value as Tab)}
      >
        {Object.keys(tabs).map(tab => (
          <Tab key={tab} value={tab}>
            {tab}
          </Tab>
        ))}
      </TabList>
      <div className={styles.content}>{children}</div>
    </Page>
  );
};

export default MasterLists;
